import _ from 'lodash'
import {type Location} from '../store/state/locations/state'
import {type VesselTag} from '../api/vessels/vessel-tags'

export const NoTagSymbol = Symbol('NO_TAG')
type Tag = string | typeof NoTagSymbol
export type TagsWithLocations = Map<Tag, Location[]>

/**
 * Groups locations by their tags
 */
export function getTagsWithLocations(locations: Location[], tags: VesselTag[]): TagsWithLocations {
    let tagsWithLocation: TagsWithLocations = new Map()

    for (const vessel of locations) {
        // Assign vessel with no tags
        // to its own special category
        if (!vessel.tags || vessel.tags.length === 0) {
            if (!tagsWithLocation.has(NoTagSymbol)) {
                tagsWithLocation.set(NoTagSymbol, [])
            }
            tagsWithLocation.get(NoTagSymbol)?.push(vessel)
            // Skip to next iteration since this vessel has no tags
            continue
        }

        // Process tags for vessels that have them
        for (const tag of vessel.tags) {
            // Skip if user don't have access to the tag
            const tagExist = tags.find((okTag) => okTag.identity === tag.identity)
            if (!tagExist) {
                continue
            }

            if (!tagsWithLocation.has(tag.name)) {
                tagsWithLocation.set(tag.name, [])
            }
            tagsWithLocation.get(tag.name)?.push(vessel)
        }
    }

    // Sort tagsWithLocation alphabetically by tag name,
    // lodash will put symbol at the end
    tagsWithLocation = new Map(_.sortBy(Array.from(tagsWithLocation), [(tag) => tag[0]]))
    // Sort locations in the tags alphabetically
    for (const [tag, locations] of tagsWithLocation) {
        tagsWithLocation.set(
            tag,
            _.sortBy(locations, (vessel) => vessel.description),
        )
    }

    return tagsWithLocation
}
